var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('page-section',{attrs:{"title":"Forum/wiki","icon":"it-files","id":"my-desk"}},[(!_vm.disabled)?_c('create-card',{on:{"add":_vm.onAdd}}):_vm._e(),_c('post-list',{ref:"postList",staticClass:"mt-5"}),_c('create-post-modal',{ref:"createPostModal",on:{"created":_vm.onCreated}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }